import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';

const generateDocDefTemplate2 = async (invoiceDetails, obj) => {

    
    const formatNumber = (num) => {
        num = num + ''; // Número a cadena
        var str = ""; // Acumulación de cadenas
        for (var i = num.length - 1, j = 1; i >= 0; i--, j++) {
            if (j % 3 == 0 && i != 0) {// Se agrega una coma cada tres dígitos para filtrar el caso donde es exactamente el primer dígito
                str += num[i] + "."; // Agrega una coma de miles
                continue;
            }
            str += num[i]; // Para acumular números al revés
        }
        return str.split('').reverse().join(""); // String => Array => Reverse => String
    };
    
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };


    let emision = moment(obj.fecha_emision).format('L');
    let vencimiento = moment(obj.vencimiento).format('L');

    let subtotal = 0;
    let copagos = 0;
    let total = 0;

    let itemBody = [
        [
            {
                text: "Factura",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Fecha",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Autorizacion",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Historia",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Paciente",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "L_Procedimiento",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "#_Sesiones",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Valor Procedimiento x Item",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Valor Copago x Item",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Valor Neto x Item",
                style: "tableHeader",
                alignment: "center",
            },
        ],
    ];
    let itemArr = ["", "", "", "", "", "", "", "", "", ""];

    if (invoiceDetails.length === 0) {
        itemBody.push(itemArr)
    }

    for (let index = 0; index < invoiceDetails.length; index++) {
        const element = invoiceDetails[index];
        itemBody.push([
            { text: obj.num_fac_ter, alignment: "center" },
            { text: element.fecha, alignment: "center" },
            { text: element.codigo_autorizacion, alignment: "center" },
            { text: element.num_documento, alignment: "center" },
            { text: element.nombre_paciente, alignment: "center" },
            { text: element.l_procedimiento, alignment: "center" },
            { text: element.num_sesiones, alignment: "center" },
            { text: element.valor_servicio_item, alignment: "center" },
            { text: element.valor_copago_item, alignment: "center" },
            { text: element.valor_neto_item, alignment: "center" }
        ]);

        subtotal = parseInt(subtotal) + parseInt(element.valor_servicio_item);
        copagos = parseInt(copagos) + parseInt(element.valor_copago_item);
        total = parseInt(total) + parseInt(element.valor_neto_item);
    }

    let itemBodyTotals = [
        [
            [
                { text: "Subtotal", alignment: "center",bold: true},
                { text: "$ " + formatNumber(subtotal), alignment: "center" },
            ],
            [
                { text: "Copagos", alignment: "center",bold: true},
                { text: "$ " +formatNumber(copagos), alignment: "center" },
            ],
            [
                { text: "Total", alignment: "center",bold: true},
                { text: "$ "+formatNumber(total), alignment: "center" },
            ]
        ],
    ];

    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },
        },
    };



    var docDefinition = {
        pageSize: "LEGAL",
        pageOrientation: 'landscape',
        info: {
            title: "PDF_" + obj.num_fac_ter.split("-")[0] + obj.num_fac_ter.split("-")[1],
            author: "",
        },
        content: [
            {
                columns: [
                    {
                        width: "*",
                        alignment: "left",
                        columns: [
                            {
                                image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + sessionStorage.getItem('id_clinica') + "/logo/" + sessionStorage.getItem('token')),
                                fit: [200, 100],
                            },
                        ],
                    },
                    {
                        width: "*",
                        alignment: "center",
                        text: [
                            {
                                text: "Relación de Usuarios",
                                bold: true
                            },
                        ],
                    },
                    {
                        width: "*",
                        alignment: "right",
                        text: [
                            {
                                text: sessionStorage.getItem('nombre_empresa') + "\n" + sessionStorage.getItem('nit_empresa') + "\n" + sessionStorage.getItem('direccion_empresa') + "\n" + sessionStorage.getItem('telefono_emrpesa') + "\n",
                            },
                        ],
                    },
                ],
            },
            {
                text: "\n",
            },
            {
                canvas: [
                    { type: "line", x1: 0, y1: 0, x2: 925, y2: 0, lineWidth: 1 },
                ],
            },
            {
                text: "\n",
            },
            /*{
                text: obj.nombre_facturado + "\n" + obj.num_documento + "\n",
            },*/
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    width: "auto",
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
            {
                style: "tableExample2",
                table: {
                    headerRows: 1,
                    widths: [150,150,150],
                    //keepWithHeaderRows: 1,
                    body: itemBodyTotals,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            }
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 15, 0, 80],
                fontSize: 7,
            },
            tableExample2: {
                margin: [0, -50, 0, 80],
                fontSize: 10,
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: "black",
            },
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default generateDocDefTemplate2;